import { render, staticRenderFns } from "./WithholdingList.vue?vue&type=template&id=435b8df4&scoped=true&"
import script from "./WithholdingList.vue?vue&type=script&lang=js&"
export * from "./WithholdingList.vue?vue&type=script&lang=js&"
import style0 from "./WithholdingList.vue?vue&type=style&index=0&id=435b8df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b8df4",
  null
  
)

export default component.exports